import classNames from 'classnames';
import styles from './BlockContainer.module.scss';

const BlockBody = ({ children, className, style, noGutters = false, ...props }) => {
  return (
    <div
      {...props}
      className={classNames(styles['block-container__body'], className, {
        [styles['block-container__body--noGutters']]: noGutters,
      })}
      style={style}
    >
      {children}
    </div>
  );
};

export { BlockBody as default, BlockBody };
